import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { OrderService } from 'src/app/services/order.service';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-accountdetails',
  templateUrl: './accountdetails.component.html',
  styleUrls: ['./accountdetails.component.css']
})
export class AccountdetailsComponent implements OnInit {

  orderId!: number;
  cartItems: any[] = []; wishlistCount: number = 0;
  cartCount: number = 0;
  order: any;
  events: any[] = [];
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
  commande: any;

  isLoggedIn = false;
  constructor(
    private route: ActivatedRoute,
    private cartService: CartService ,private wishlist : WishlistService,
    private authService: AuthServiceService,
    private router: Router,
     private scriptLoader: ScriptLoaderService,
    private orderService: OrderService // Crée ce service si tu ne l’as pas encore
  ) {}



  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.orderId = +id;
        this.loadOrderDetails(this.orderId);
      }
    });
  }
  getTotalArticles(): number {
    return this.order.lignes_commande.reduce(
      (total: number, ligne: any) => total + ligne.nbr_article,
      0
    );
  }
 goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  logout() {
    this.authService.logout();
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('clientId'); // Supprime également le client ID
    this.isLoggedIn = false;
    this.router.navigate(['/home']); // Redirige vers la page d'accueil
  }
  loadOrderDetails(orderId: number): void {
    this.orderService.getOrderById(orderId).subscribe({
      next: (order) => {
        this.order = order;
        this.events = order.historique?.map((h: any) => {
          const etat = this.getEtatById(h.status);
          return {
            status: etat?.libelle,
            date: h.date,
            color: etat?.code_couleur,
            icon: etat?.icone,
          };
        }) || [];
        console.log('✅ Détails de la commande :', this.order);
        console.log('📜 Timeline :', this.events);
      },
      error: (err) => {
        console.error('❌ Erreur de récupération de la commande :', err);
      }
    });
  }

  getEtatById(statusId: number): any {
    const etats = [
      { id: 2, libelle: "Confirmé", code_couleur: "#008000", icone: "bi-check-circle" },
      { id: 1, libelle: "En attente", code_couleur: "#ffa500", icone: "bi-clock" },
      { id: 3, libelle: "Annulé", code_couleur: "#ff0000", icone: "bi-x-circle" },
      { id: 4, libelle: "Chez livreur", code_couleur: "#0000ff", icone: "bi-truck" },
      { id: 6, libelle: "Retour non reçu", code_couleur: "#ffa500", icone: "bi-arrow-right-circle" },
      { id: 5, libelle: "Reporté", code_couleur: "#696969", icone: "bi-arrow-repeat" },
      { id: 8, libelle: "Payée", code_couleur: "#0000ff", icone: "bi-cash-coin" },
      { id: 7, libelle: "Retour reçu", code_couleur: "#008000", icone: "bi-arrow-left-circle" }
    ];

    return etats.find(etat => etat.id === statusId) || { libelle: "Inconnu", code_couleur: "#000000", icone: "bi-question" };
  }
}
